import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=304ec968&"
import script from "./VideoDetail.vue?vue&type=script&lang=ts&"
export * from "./VideoDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports